import pigCalendarApi from "@/api/pig-calendar/pigCalendarApi";
export default {
  namespaced: true,
  state: {
    weekSelector: []
  },
  mutations: {
    setWeekSelector(state, data) {
      state.weekSelector = data;
    }
  },
  actions: {
    async fetch() {
      try {
        const result = await pigCalendarApi.fetch();
        return Promise.resolve(result.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchByCategory(_, {categoryId}) {
      try {
        const result = await pigCalendarApi.fetchByCategory(categoryId);
        return Promise.resolve(result.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchCurrentAndFuture(_, {categoryId, count}) {
      try {
        const result = await pigCalendarApi.fetchCurrentAndFuture(categoryId, count);
        return Promise.resolve(result.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchLastAndNext(_, {categoryId, last, next}) {
      try {
        const result = await pigCalendarApi.fetchLastAndNext(categoryId, last, next);
        return Promise.resolve(result.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setWeekSelector({commit}, data) {
      commit('setWeekSelector', data);
    }
  }
}
